/**
 * calmont-custom.js
 * Calmont Anpassung: Zentrale Datei fuer alle custom JS-Anpassungen
 */

/* ============================================================
   Calmont Anpassung: Sticky Mobile ATC Bar — CAL-003
   Bundle-Erkennung via window.cartMax_meta:
   Prueft ob das aktuelle Produkt eine Volume-Config hat (qty > 1)
   → "Option waehlen" + Scroll zum Bundle
   → Sonst: nativer ATC laeuft durch
   ============================================================ */
(function () {
  if (window.innerWidth >= 768) return;
  if (!window.location.pathname.includes('/products/')) return;

  var ENHANCED = 'cal003-enhanced';

  // Calmont Anpassung: Prueft CartMax config ob aktuelles Produkt
  // eine Mengenauswahl hat (1x/2x/4x = Volume Bundle)
  function hasVolumeBundle() {
    try {
      var meta = window.cartMax_meta && window.cartMax_meta.config;
      if (!meta || !meta.config_check || !meta.config_check.length) return false;

      // Produkt-ID aus Shopify
      var pid = window.ShopifyAnalytics &&
                window.ShopifyAnalytics.meta &&
                window.ShopifyAnalytics.meta.product &&
                window.ShopifyAnalytics.meta.product.id;
      if (!pid) return false;

      // Config fuer dieses Produkt finden
      var entry = null;
      for (var i = 0; i < meta.config_check.length; i++) {
        if (meta.config_check[i].trigger &&
            meta.config_check[i].trigger.indexOf(pid) !== -1) {
          entry = meta.config_check[i];
          break;
        }
      }
      if (!entry) return false;

      var config = meta.configs && meta.configs[entry.config_id];
      if (!config) return false;

      var rules = config.rules &&
                  config.rules.settings &&
                  config.rules.settings.discount_rules;
      if (!rules) return false;

      // Volume Bundle = mind. 2 Optionen mit unterschiedlichen Mengen
      var maxQty = 0;
      for (var j = 0; j < rules.length; j++) {
        if (rules[j].quantity > maxQty) maxQty = rules[j].quantity;
      }
      return maxQty > 1;
    } catch (e) {
      return false;
    }
  }

  function getProductInfo() {
    var titleEl = document.querySelector('h1.product__title, .product__title, h1');
    var priceEl = document.querySelector('price-list.price-list--lg sale-price');
    var imgEl   = document.querySelector(
      '.product__media-item.is-selected img, .product__media-item img, .product__media img'
    );
    var title    = titleEl ? titleEl.innerText.trim() : '';
    var rawPrice = priceEl ? (priceEl.innerText || '').replace(/\s+/g, ' ').trim() : '';
    var price    = rawPrice.replace(/^Angebot\s*/i, '').trim();
    var imgSrc   = imgEl ? (imgEl.currentSrc || imgEl.src || imgEl.dataset.src || '') : '';
    return { title: title, price: price, imgSrc: imgSrc };
  }

  function scrollToBundle() {
    var target =
      document.querySelector('cartmax-product-recommend[cartmax-type="2"]') ||
      document.querySelector('volume-card') ||
      document.querySelector('.product-info__buy-buttons') ||
      document.querySelector('[data-block-type="buy-buttons"]');
    if (target) {
      var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function enhance() {
    var quickAdd = document.querySelector('product-quick-add');
    if (!quickAdd || quickAdd.classList.contains(ENHANCED)) return;

    var mobileBtns = quickAdd.querySelector('buy-buttons');
    if (!mobileBtns) return;

    var info = getProductInfo();
    if (!info.title && !info.price) return;

    var isBundle = hasVolumeBundle();

    quickAdd.classList.add(ENHANCED);
    mobileBtns.classList.add('cal003-btn-wrap');

    var titleShort = info.title.length > 26 ? info.title.slice(0, 24) + '\u2026' : info.title;

    var topRow = document.createElement('div');
    topRow.className = 'cal003-top';

    if (info.imgSrc) {
      var img = document.createElement('img');
      img.className = 'cal003-thumb';
      img.src = info.imgSrc;
      img.alt = '';
      topRow.appendChild(img);
    }

    var textEl = document.createElement('div');
    textEl.className = 'cal003-text';
    textEl.innerHTML =
      '<span class="cal003-title">' + titleShort + '</span>' +
      '<span class="cal003-price">' + info.price + '</span>';
    topRow.appendChild(textEl);
    topRow.appendChild(mobileBtns);
    quickAdd.insertBefore(topRow, quickAdd.firstChild);

    if (isBundle) {
      var btn = mobileBtns.querySelector('button');
      if (btn) {
        var lbl = btn.querySelector('div');
        if (lbl) lbl.textContent = 'Option w\u00e4hlen';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          scrollToBundle();
        }, true);
      }
    }

    var kpiBar = document.createElement('div');
    kpiBar.className = 'cal003-kpi-bar';
    kpiBar.innerHTML =
      '<span>\u2713 60 N\u00e4chte Probeschlafen</span>' +
      '<span class="cal003-kpi-dot">\u00b7</span>' +
      '<span>\u2605 2.000+ zufriedene Kunden</span>';
    var variant = quickAdd.querySelector('.product-quick-add__variant');
    quickAdd.insertBefore(kpiBar, variant || null);
  }

  var attempts = 0;
  var timer = setInterval(function () {
    enhance();
    if (document.querySelector('product-quick-add.' + ENHANCED) || ++attempts >= 20) {
      clearInterval(timer);
    }
  }, 500);

  document.addEventListener('page:load', function () {
    if (window.innerWidth < 768 && window.location.pathname.includes('/products/')) {
      attempts = 0;
      timer = setInterval(function () {
        enhance();
        if (document.querySelector('product-quick-add.' + ENHANCED) || ++attempts >= 20) {
          clearInterval(timer);
        }
      }, 500);
    }
  });
})();
